export const CREATE_ACCOUNT_LINK = 'create-account-link';
export const FORGOT_PASSWORD_LINK = 'forgot-password-link';
export const LOGIN_BUTTON = 'login-button';
export const FORM_ROOT = 'customer-login-form';
